import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Link, 
  IconButton,
  Divider,
  Stack
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import QrCodeIcon from '@mui/icons-material/QrCode';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'background.paper',
        py: 6,
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <QrCodeIcon sx={{ mr: 1, color: 'primary.main' }} />
              <Typography variant="h6" component={RouterLink} to="/" sx={{ textDecoration: 'none', color: 'text.primary', fontWeight: 700 }}>
                QResto
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" paragraph>
              Transforming restaurant menus with augmented reality experiences through simple QR codes.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton size="small" color="primary" aria-label="facebook">
                <FacebookIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" color="primary" aria-label="twitter">
                <TwitterIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" color="primary" aria-label="instagram">
                <InstagramIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" color="primary" aria-label="linkedin">
                <LinkedInIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Grid>
          
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Company
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li>
                <Link component={RouterLink} to="/" color="text.secondary" sx={{ display: 'block', mb: 1, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                  Home
                </Link>
              </li>
              <li>
                <Link component={RouterLink} to="/about" color="text.secondary" sx={{ display: 'block', mb: 1, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                  About Us
                </Link>
              </li>
              <li>
                <Link component={RouterLink} to="/contact" color="text.secondary" sx={{ display: 'block', mb: 1, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                  Contact
                </Link>
              </li>
            </ul>
          </Grid>
          
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Services
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li>
                <Link component={RouterLink} to="/pricing" color="text.secondary" sx={{ display: 'block', mb: 1, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                  Pricing
                </Link>
              </li>
              <li>
                <Link component={RouterLink} to="/faq" color="text.secondary" sx={{ display: 'block', mb: 1, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                  FAQ
                </Link>
              </li>
              <li>
                <Link component={RouterLink} to="/contact" color="text.secondary" sx={{ display: 'block', mb: 1, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                  Support
                </Link>
              </li>
            </ul>
          </Grid>
          
          <Grid item xs={6} md={4}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              WhatsApp / Call: +91 7240255101
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Address: Jaipur, Rajasthan
            </Typography>
          </Grid>
        </Grid>
        
        <Divider sx={{ mt: 6, mb: 3 }} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} QResto. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', mt: { xs: 2, md: 0 } }}>
            <Link component={RouterLink} to="/privacy-policy" color="text.secondary" sx={{ mx: 2, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
              <Typography variant="body2">Privacy Policy</Typography>
            </Link>
            <Link component={RouterLink} to="/terms-of-service" color="text.secondary" sx={{ mx: 2, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
              <Typography variant="body2">Terms of Service</Typography>
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;